import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Row, Col, Form, InputGroup, Image, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { setUser, setAuthField, setToken, initializeAuthFields } from '../../store/reducers/userReducer';
import { setLoading, setErrors, initializeErrors } from '../../store/reducers/commonReducer';
import Http from '../../services/Http';
import LoadingContainer from '../../components/LoadingContainer';
import { LogoIconPurple, MailIcon, PassIcon, loginPageImg } from '../../services/Assets';
import Cookies from 'js-cookie';  
import './Login.css';
import { useTranslation } from 'react-i18next';
import '../../i18n'

const FormGroup = Form.Group;
const Input = Form.Control;

const MemberLogin = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { teamId } = useParams();
  const user = teamId;
  const [teamCodeShow, setTeamCodeShow] = useState(false);
  const { email, teamCode } = useSelector(state => state.user);
  const { loading, formValidate, errors } = useSelector(state => state.common);
  useEffect(() => {
    return (() => {
      dispatch(initializeErrors());
      dispatch(initializeAuthFields());
    });
  }, [dispatch]);

  const changeAuthField = (e) => {
    dispatch(initializeErrors());
    dispatch(setAuthField({ val: e.target.value, key: e.target.name }));
  };

const login = async () => {
  try {
    const validationErrors = formValidate({ email, teamCode });
    if (Object.keys(validationErrors).length > 0) {
      dispatch(setErrors(validationErrors));
      return;
    }

    dispatch(setLoading(true));

    const storedUser = localStorage.getItem('user');
    if (!storedUser) {
    toast.error("User context missing. Please login again.")
    return
    }

    const { email: myEmail } = JSON.parse(storedUser);

    const loginResponse = await Http.post('/auth/login-team', { email, teamCode });

    if (!loginResponse.data.status) {
    toast.error("Invalid Credentials")
    return
    }

    const verificationResponse = await Http.post('/auth/team-verification', {
      user: loginResponse.data.user.id,
      myEmail
    });
  
    const accessLevel = verificationResponse.data.user?.[0]?.accessLevel;
    const teamId = verificationResponse.data.user?.[0]?.id;

    if (!accessLevel || !teamId) {
     toast.error("Team verification failed.")
    return
    }

    Cookies.set('accessMode', accessLevel);
    Cookies.set('teamId', teamId);

    dispatch(setUser(loginResponse.data.user));
    dispatch(setToken(loginResponse.data.token));
    toast.success("Logged in successfully!");
    navigate('/dashboard');

  } catch (err) {
    console.error("Login failed:", err.message);
    dispatch(setLoading(false));
    toast.error(err.message || "Something went wrong. Please try again.");
    navigate('/login');
  } finally {
    dispatch(setLoading(false));
  }
};


  return (
    <div className='login'>
      <Container>
        <Row className='justify-content-center align-items-center vh-100'>
          <Col xxl={9} xl={12}>
            <div className="d-flex flex-md-row flex-column login-con rounded-4 my-md-0 my-4 overflow-hidden">
              <div className="login-left-side p-4">
                <img src={loginPageImg} alt="image" />
              </div>
              <div className='login-inner'>
                <Image src={LogoIconPurple} id='logo-icon' />
                <div className='login-head'>
                  <h1>{t('Log in As the member')}</h1>
                  <p>{t('Please fill Member Credential')}</p>
                </div>
                <div className='form'>
                  <FormGroup>
                    <InputGroup className='mb-2'>
                      <Input type='email' placeholder={t('Enter email')} name='email' onChange={changeAuthField} />
                      <Image src={MailIcon} style={{ zIndex: 99999 }} />
                      {errors && errors.email && <p className='text-danger'>{errors.email}</p>}
                    </InputGroup>
                  </FormGroup>
                  <InputGroup>
                    <Input type={teamCodeShow ? 'text' : 'password'} name='teamCode' placeholder={t('Enter team code')} onChange={changeAuthField} />
                    <Image src={PassIcon} className='lockImg' />
                    {errors && errors.teamCode && <p className='text-danger'>{errors.teamCode}</p>}
                  </InputGroup>
                  <Button className='login-btn' size='lg' onClick={login}>{t('Log in')}</Button>
                </div>
                <a href="https://teknikforce.com/" target="_blank">
                  <img src="https://teknikforce.com//assets/frontimage/logoaboutus.png" alt="Teknikforce" className="img-fluid p-2 company-logo" />
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {loading && <LoadingContainer />}
    </div>
  );
};

export default MemberLogin;